"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var lodash_1 = require("lodash");
var react_apollo_1 = require("react-apollo");
var creatable_1 = require("react-select/creatable");
var SetFeedbackMessage = require("../../core/gql/mutations/set-feedback-message");
var CreateTag = require("../../core/gql/mutations/create-tag");
var DeleteTag = require("../../core/gql/mutations/delete-tag");
var QueryTags = require("../../core/gql/queries/tags");
var tag_1 = require("../../models/tag");
var OrgTagInfo = (_a = {},
    _a[tag_1.TagType.AREA_OF_OPERATION] = {
        label: "Areas of Operation",
        placeholder: "Type an area of operation...",
        helpText: "",
        defaultOptions: [{ label: "Primary", value: "Primary" }],
        requiresOne: true
    },
    _a[tag_1.TagType.AGE_DIVISION] = {
        label: "Age Divisions",
        placeholder: "Select or type an age division...",
        helpText: "",
        defaultOptions: [
            { label: "U6", value: "U6" },
            { label: "U7", value: "U7" },
            { label: "U8", value: "U8" },
            { label: "U9", value: "U9" },
            { label: "U10", value: "U10" },
            { label: "U11", value: "U11" },
            { label: "U12", value: "U12" },
            { label: "U13", value: "U13" },
            { label: "U14", value: "U14" },
            { label: "U15", value: "U15" },
            { label: "U16", value: "U16" },
            { label: "U17", value: "U17" },
            { label: "U18", value: "U18" },
            { label: "6U", value: "6U" },
            { label: "7U", value: "7U" },
            { label: "8U", value: "8U" },
            { label: "9U", value: "9U" },
            { label: "10U", value: "10U" },
            { label: "11U", value: "11U" },
            { label: "12U", value: "12U" },
            { label: "13U", value: "13U" },
            { label: "14U", value: "14U" },
            { label: "15U", value: "15U" },
            { label: "16U", value: "16U" },
            { label: "17U", value: "17U" },
            { label: "18U", value: "18U" },
        ]
    },
    _a[tag_1.TagType.COMPETITION_GENDER] = {
        label: "Competition Genders",
        placeholder: "Select or type a competition gender...",
        helpText: "",
        defaultOptions: [
            { label: "Girls", value: "Girls" },
            { label: "Boys", value: "Boys" },
            { label: "Coed", value: "Coed" },
            { label: "Women", value: "Women" },
            { label: "Men", value: "Men" },
        ]
    },
    _a[tag_1.TagType.COMPETITION_LEVEL] = {
        label: "Competition Levels",
        placeholder: "Select or type a competition level...",
        helpText: "",
        defaultOptions: [
            { label: "AAA", value: "AAA" },
            { label: "AA", value: "AA" },
            { label: "A", value: "A" },
            { label: "B", value: "B" },
            { label: "C", value: "C" },
            { label: "Gold", value: "Gold" },
            { label: "Silver", value: "Silver" },
            { label: "Bronze", value: "Bronze" },
        ]
    },
    _a);
var components = {
    DropdownIndicator: null,
};
var buildTagOptionValue = function (tag) {
    return { label: tag.name, value: tag.id, tag: tag };
};
var OrgTag = function (_a) {
    var _b;
    var tagTypeName = _a.tagTypeName, orgId = _a.orgId, orgTags = _a.orgTags;
    var tagTypeData = OrgTagInfo[tagTypeName];
    var tagValues = tag_1.unarchivedOrgTagsForType(orgTags, tagTypeName).map(buildTagOptionValue);
    var mutationOptions = {
        refetchQueries: [{ query: QueryTags.QUERY, variables: { organizationId: orgId } }],
    };
    var _c = react_apollo_1.useMutation(CreateTag.MUTATION, mutationOptions), createTag = _c[0], createTagResponse = _c[1];
    var _d = react_apollo_1.useMutation(DeleteTag.MUTATION, mutationOptions), deleteTag = _d[0], deleteTagResponse = _d[1];
    var setFeedbackMessage = react_apollo_1.useMutation(SetFeedbackMessage.MUTATION)[0];
    var _e = React.useState(''), inputValue = _e[0], setInputValue = _e[1];
    var _f = React.useState([]), stateTagValues = _f[0], setStateTagValues = _f[1];
    React.useEffect(function () {
        setStateTagValues(tagValues);
    }, [orgTags]);
    var addNewTag = function (newValue) { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, createTag({
                            variables: {
                                organizationId: orgId,
                                type: tagTypeName,
                                name: newValue,
                            },
                        })];
                case 1:
                    _b.sent();
                    return [3 /*break*/, 3];
                case 2:
                    _a = _b.sent();
                    setStateTagValues(tagValues);
                    setFeedbackMessage({
                        variables: {
                            message: "Failed to add \"" + newValue + "\" to " + tagTypeData.label + ".",
                            isError: true,
                            autoclose: true,
                        },
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var removeTag = function (tagOption) { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, deleteTag({
                            variables: {
                                organizationId: orgId,
                                id: tagOption.value,
                            },
                        })];
                case 1:
                    _b.sent();
                    return [3 /*break*/, 3];
                case 2:
                    _a = _b.sent();
                    setStateTagValues(tagValues);
                    setFeedbackMessage({
                        variables: {
                            message: "Failed to remove \"" + tagOption.tag.name + "\" from " + tagTypeData.label + ".",
                            isError: true,
                            autoclose: true,
                        },
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleChange = function (newTagValues, _actionMeta) {
        var removed = lodash_1.difference(stateTagValues, newTagValues);
        var added = lodash_1.difference(newTagValues, stateTagValues);
        var tagRemoved = removed && removed.length === 1;
        var changedTag = (tagRemoved && removed[0]) || (added && added.length === 1 && added[0]);
        if (changedTag) {
            // update state to assume immediate success
            setStateTagValues(newTagValues);
            if (tagRemoved) {
                removeTag(changedTag);
            }
            else {
                addNewTag(changedTag.label);
            }
        }
    };
    var handleInputChange = function (newValue) {
        setInputValue(newValue);
    };
    var isValidNewOption = function (inputValue, selectValue, selectOptions) {
        if (inputValue.trim().length === 0 ||
            selectValue.find(function (option) { return option.label.toLowerCase() === inputValue.trim().toLowerCase(); }) ||
            selectOptions.find(function (option) { return option.label.toLowerCase() === inputValue.trim().toLowerCase(); })) {
            return false;
        }
        return true;
    };
    var isSubmitting = createTagResponse.loading || deleteTagResponse.loading;
    var options = (_b = tagTypeData.defaultOptions) === null || _b === void 0 ? void 0 : _b.filter(function (option) {
        return !(stateTagValues === null || stateTagValues === void 0 ? void 0 : stateTagValues.find(function (tagOption) { return tagOption.label === option.label; }));
    });
    return (React.createElement("div", { className: "u-padBottomXl" },
        React.createElement("h3", { className: "u-padBottomSm" }, tagTypeData.label),
        React.createElement("div", null, tagTypeData.helpText),
        React.createElement(creatable_1.default, { isDisabled: isSubmitting, isLoading: isSubmitting, components: components, isMulti: true, isClearable: false, placeholder: tagTypeData.placeholder, inputValue: inputValue, value: stateTagValues, onInputChange: handleInputChange, onChange: handleChange, createOptionPosition: "last", options: options, noOptionsMessage: function () { return "Type a new value"; }, isValidNewOption: isValidNewOption })));
};
exports.default = OrgTag;
//# sourceMappingURL=organization-tag.js.map